import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import mainPhotoCatLeft from '@assets/images/home-cat-left.webp';
import mainPhotoCatRight from '@assets/images/home-cat-right.webp';



interface MainPhotoProps {
	scrollToCollar: () => void,
	scrollToProbe: () => void
}


const MainPhoto = (props: MainPhotoProps) => {
	const { scrollToCollar, scrollToProbe } = props;
	const { t } = useTranslation('web');

	return (
		<div className='main-photo'>
			
			<div className='main-photo-text disable-selection cats-text' onClick={scrollToCollar}>
				<p className='contact-phone-number'>{t('pages.home.cats.mainPhoto.phoneNumberLabel')} {t('shared.contactPhoneNumber')}</p>
				
				<p className='main-title'>{t('pages.home.cats.mainPhoto.collarTitle')}</p>

				<Link to={NavigateRoutesEnum.catOrder} className='app-main-button cats-button'
					onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation() }}>
					{t('shared.orderLongUpper')}
				</Link>
			</div>

			<div className='main-photo-text disable-selection cats-text' onClick={scrollToProbe}>
				<p>{t('pages.home.cats.mainPhoto.probeTitle')}</p>

				<Link to={NavigateRoutesEnum.partners} className='app-main-button cats-button'
					onClick={(e: MouseEvent<HTMLAnchorElement>) => { e.stopPropagation() }}>
					{t('shared.orderLongUpper')}
				</Link>
			</div>
			
			<div className='main-photo-image-cats'>
				<img src={mainPhotoCatLeft} alt='main-content-photo' />
				<img src={mainPhotoCatRight} alt='main-content-photo' />
			</div>
		
		</div>
	);
};

export default MainPhoto;